
import { Vue, Component, Prop,Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "dicTypeSelect",
  components: {
  },
})
export default class dicTypeSelect extends BaseVue {
  @Model('on-change') defaultValue!: any

  @Prop({ default: () => "" }) whereCode!: String; //字典类型编码
  @Prop({ default: () => true }) firstIsSelected!: Boolean; //默认选中第一项
  @Prop({ default: () => true }) isAll!: Boolean; //是否有全部选项
  // @Prop({ default: () => "" }) value!: any; //下拉列表值
  @Prop({ default: () => false }) disabled!: Boolean; //是否禁用
  @Prop({ default: () => "" }) name!: String; //下拉列表name
  @Prop({ default: () => true }) transfer!: Boolean; //下拉列表transfer   置于body内
  @Prop({ default: () => false }) clearable!: Boolean; //下拉列表clearable 清除
  @Prop({ default: () => "请选择" }) placeholder!: String; //下拉列表placeholder
  @Prop({ default: () => true }) filterable!: Boolean; //下拉列表filterable 搜索

  selOptions:any=[]
  async mounted() {    
  }
  onSelect(value){
    this.$emit("on-select",value)
  }
  onChange(value){
    this.$emit("on-change",value)
  } 
}
